/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import ShowHidePassword from "App/common/ui/ShowHidePassword";
import { updateProfileDetailsStart, reEnterPasswordStart } from "store/actions";
import { objectToArray, checkValidity } from "utils";

function PasswordAuth(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const [form, setForm] = useState({
    reEnterPassword: {
      key: "reEnterPassword",
      title: "Enter your current password",
      type: "password",
      value: "",
      validation: { required: true, isPassword: true },
      valid: true,
      error: ""
    }
  });

  useEffect(() => {
    lMethods.updatePopupParams({
      execute: formSubmitHandler
    });
  }, [form]);

  useEffect(() => {
    lMethods.updatePopupParams({
      loading: props.reEnterPassword.loading,
      error: props.reEnterPassword.error
    });

    if (props.reEnterPassword.updated) lMethods.closePopup();
  }, [props.reEnterPassword]);

  function inputChangeHandler(key, value) {
    const updatedForm = { ...form };
    const updatedInput = { ...updatedForm[key] };

    updatedInput.value = value ? value.trim() : "";

    updatedForm[key] = updatedInput;

    setForm(updatedForm);
  }

  function formSubmitHandler() {
    let isFormValid = true;
    const updatedForm = { ...form };
    const reEnterPasswordDetails = {};

    for (let key in updatedForm) {
      const updatedInput = { ...updatedForm[key] };

      const validationObj = checkValidity(
        updatedInput.value ? updatedInput.value : "",
        updatedInput.validation,
        key
      );

      updatedInput.valid = validationObj.isValid;
      updatedInput.error = validationObj.errMsg;

      if (!updatedInput.valid) isFormValid = false;

      updatedForm[key] = updatedInput;
      reEnterPasswordDetails[key] = updatedInput.value;
    }

    setForm(updatedForm);

    if (isFormValid) {
      props.reEnterPasswordStart();
      props.updateProfileDetailsStart({
        ...lState.popup.params.updatedDetails,
        password: reEnterPasswordDetails["reEnterPassword"]
      });
    }
  }

  return (
    <React.Fragment>
      {objectToArray(form).map((input, index) => (
        <div className="err_msg_wrap" key={index}>
          <p className="popup_label">{input.title}</p>
          <div className="pwd-icon">
            <input
              type={input.type}
              className="input_text"
              onChange={e => inputChangeHandler(input.key, e.target.value)}
              autoFocus={input.key === "reEnterPassword"}
            />

            <ShowHidePassword
              show={input.type === "text"}
              state={form}
              setState={setForm}
              path={input.key}
            />
          </div>

          {!input.valid && (
            <div>
              <span className="error-msg">{input.error}</span>
            </div>
          )}
        </div>
      ))}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    reEnterPassword: state.account.reEnterPassword,
    userDetails: state.account.userDetails
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { updateProfileDetailsStart, reEnterPasswordStart },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordAuth);
